var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96962 24.9815H10.9693M12.9491 12.9627L15.0689 15.0825M24.9679 7.9832V10.9829M41.9662 24.9815H38.9665M42.2322 40.18C37.1637 36.6822 31.1251 34.8636 24.9679 34.9805C18.8107 34.8636 12.7722 36.6822 7.70364 40.18M1.97021 24.9815C1.97022 37.6828 12.2666 47.9792 24.9679 47.9792C37.6692 47.9792 47.9656 37.6828 47.9656 24.9815C47.9656 12.2802 37.6692 1.9838 24.9679 1.9838C12.2666 1.9838 1.97021 12.2802 1.97021 24.9815ZM27.7956 27.8092C26.2263 29.325 23.7317 29.3033 22.1889 27.7605C20.6461 26.2177 20.6245 23.7231 22.1402 22.1538C23.702 20.5919 38.4026 11.5548 38.4026 11.5548C38.4026 11.5548 29.3675 26.2474 27.7956 27.8092Z",
    stroke: "#AD88C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.db38348c7393838a7d7eeee1b3470327.svg";
export { ForwardRef as ReactComponent };